var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBecomeKol = function SvgBecomeKol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#303030",
    strokeLinejoin: "round",
    clipPath: "url(#clip0_1543_45120)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M19.75 11v4.29c0 1.386 0 2.08-.27 2.609A2.47 2.47 0 0 1 18.4 18.98c-.53.27-1.223.27-2.609.27H7.21c-1.386 0-2.08 0-2.609-.27A2.48 2.48 0 0 1 3.52 17.9c-.27-.53-.27-1.223-.27-2.609V6.71c0-1.386 0-2.08.27-2.609A2.48 2.48 0 0 1 4.6 3.02c.53-.27 1.223-.27 2.609-.27h4.29M3.37 17.54a3.3 3.3 0 0 1 3.18-2.415h5.775c.767 0 1.15 0 1.469.063a3.3 3.3 0 0 1 2.592 2.593c.064.319.064.702.064 1.469m-3.3-10.312a3.3 3.3 0 1 1-6.6 0 3.3 3.3 0 0 1 6.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.6,
    d: "m18.375 1.833.82 1.855 1.93.246-1.424 1.392.374 2.007-1.7-.994-1.7.994.374-2.007-1.424-1.392 1.93-.246z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_45120"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h22v22H.5z"
  })))));
};
export default SvgBecomeKol;